import projects from './projects'
import preventas from './preventas'
import users from './users'
import checklists from './checklists'
import myPlaces from './my-places'
import myChecklistsPending from './my-checklists'
import manual from './manual'
import helpDesk from './help-desk'
import integraciones from './integraciones'

export default [projects, preventas, users, checklists, myPlaces, myChecklistsPending, integraciones, manual, helpDesk]
